export default "__VITE_ASSET__CNcSNG63__"